import { useState } from "react";
import DepartmentAdminFeedbackRating from "./departmentAdminFeedbackRating";
import ReactModal from "react-modal";

const DepartmentAdminFeedback = () => {
  const [showRating, setShowRating] = useState(false);

  const handleOpenModal = () =>{
    setShowRating(true);
  }
  const handleCloseModal = () =>{
    setShowRating(false);
  }
  return (
    <>
      <div className="card-wrap h-auto">
        <div className="feedbackwrap">
          <div className="title">
            <div className="w-50">
              <h2 className="mb-2">Feedback</h2>
              <p className="mb-2">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Vestibulum imperdiet lectus vel leo sollicitudin maximus at eu
                quam.
              </p>
            </div>
            <div className="d-flex justify-content-end">
              <a data-bs-toggle="modal" data-bs-target="#rateuswrap">
                <div className="d-flex align-items-center gap-2">
                  <div className="rate-star">
                    <span>
                      <i className="fa-solid fa-star"></i>
                    </span>
                    <span>
                      <i className="fa-solid fa-star"></i>
                    </span>
                    <span>
                      <i className="fa-solid fa-star"></i>
                    </span>
                    <span>
                      <i className="fa-solid fa-star"></i>
                    </span>
                    <span>
                      <i className="fa-solid fa-star-half-stroke"></i>
                    </span>
                  </div>
                  <button
                    className="btn btn-small btn-primary"
                    onClick={handleOpenModal}
                  >
                    Rate Us
                  </button>
                </div>
              </a>
            </div>
          </div>
          <div className="card emailform">
            <div className="label-to mb-3">
              <label htmlFor="">From</label>
              <div className="stude-details">
                <div className="img">
                  <img src="/assets/images/profile07.jpg" alt="" />
                </div>
                <div className="desc">
                  <h6>William Sonoma</h6>
                  <p>
                    Departement of Science | <span>Imperial College</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="formgroup mb-3">
              <label htmlFor="">Subject</label>
              <input type="text" autoFocus />
            </div>
            <div className="formgroup mb-3">
              <label htmlFor="">Message</label>
              <textarea name="" id=""></textarea>
            </div>
            <div className="btn-flex mb-4">
              <button type="button" className="btn btn-primary">
                Send
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <ReactModal
        isOpen={showRating}
        onRequestClose={handleCloseModal}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
          <DepartmentAdminFeedbackRating
            setShowRateFeedback={handleCloseModal}
          />
      </ReactModal> */}
    </>
  );
};

export default DepartmentAdminFeedback;
